/* eslint-disable no-console */
import { useTranslation } from "react-i18next";

import { useDevices } from "../hooks/use-devices";
import { useEcoStats } from "../hooks/use-eco";
import { useActiveIncidents } from "../hooks/use-incidents";
import { useRoomMonitoring } from "../hooks/use-monitor";
import { Dashboard } from "../partials/dashboard";
import { ErrorScreenWithText } from "../partials/error-screen";
import { LoadingScreenWithText } from "../partials/loading-screen";
import { PagePartial } from "../partials/page-partial";

export const DashboardPage = () => {
  const { t } = useTranslation();

  // Use the main useDevices hook to trigger initial data loading
  const { devices, error, isLoading } = useDevices();

  // Filter devices for the dashboard (exclude monitoring devices)
  const dashboardDevices = devices.filter((d) => d.class !== "monitoring");

  console.log("dashboardDevices", dashboardDevices);

  // Use the new incidents hook
  const { incidents = [] } = useActiveIncidents();

  // Room monitoring from rooms API monitoring paths
  const {
    channels: monitorChannels,
    error: monitorError,
    isLoading: monitorLoading,
  } = useRoomMonitoring();

  const { error: ecoError, isLoading: ecoLoading, stats } = useEcoStats();

  if (isLoading) return <LoadingScreenWithText />;

  if (error) return <ErrorScreenWithText error={error} />;

  return (
    <PagePartial title={t("page.dashboard")}>
      <Dashboard
        devices={dashboardDevices}
        ecoData={{
          error: ecoError,
          isLoading: ecoLoading,
          stats,
        }}
        incidents={incidents}
        monitorData={{
          error: monitorError ? new Error(monitorError) : undefined,
          isLoading: monitorLoading,
          channels: monitorChannels,
        }}
      />
    </PagePartial>
  );
};
